import BasePage from '../../../../../components/table_page';
import Form from './form';

export default {
  name: 'terminal_payment_record',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    modalClick({ val, row }) {
      console.log('val', val);
      // 查看
      if (val.code === 'view') {
        this.formName = 'Form';
        this.formConfig = { ...row, btnCode: 'view', code: 'view' };
        this.modalConfig.title = '查看';
        this.openFull();
      }
    },
  },
};
